import React from "react";
import BlogHeader from "./Header";
import "../Styles/Blog_DT_BG.css";
import heroBanner from "../../Asserts/BT_BG_img.png";

const Blog_DT_BG = () => {
  return (
    <div className="blog-dt-page">
      {/* Hero Section with Header */}
      <div
        className="blog-dt-hero-section"
        style={{ backgroundImage: `url(${heroBanner})` }}
      >
        
      </div>

      {/* Blog Title below the Hero */}
      <div className="blog-dt-title-section">
        <h1 className="blog-dt-main-title">
          We make impact to your business with our quality
          <br />
          <span> </span>
        </h1>
      </div>

      {/* Blog Content */}
      <div
        className="blog-dt-hero-section"
        style={{ backgroundImage: `url(${heroBanner})` }}
      >
        
      </div>
    </div>
  );
};

export default Blog_DT_BG;
